import { FacetSelectionType, ShSelectableFacetValue } from '@stylehaven/components';

export function toSelectableFacetValue(
    facetValue: string,
    facetLabel: string,
    selectionType: FacetSelectionType,
    count?: number,
    missing?: boolean,
    selected?: boolean
): ShSelectableFacetValue {
    return {
        value: facetValue,
        label: facetLabel,
        selectionType,
        count: count ?? 1,
        missing,
        selected: selected ?? true
    };
}
